module.exports = __webpack_public_path__ + "img/atv-ride.95e1d308.jpg";